class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/catalogues'
			},
			create: {
				headers: {
					'xt-user-token': null,
					'Content-Type': 'application/json'
				},
				method: 'post',
				path: '/catalogue/create'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/catalogue/update'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/catalogue/delete'
			}
		};
	}
}

export default new APIS();
